"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    menuButton: {
      height: '44px',
      padding: ' 16px',
      fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      fontSize: '13px',
      textTransform: 'none',
      backgroundColor: '#F7F7F7',
      color: ' #212529',
      borderRadius: '10px',
      fontWeight: typography.fontWeightRegular,
      '&:hover': {
        backgroundColor: ' #C4C4C4'
      },
      '&:disabled': {
        backgroundColor: 'rgb(210, 210, 210)',
        color: 'rgba(255, 255, 255, 0.4)'
      }
    },
    spacer: {
      margin: '0 8px'
    },
    buttonIcon: {
      marginLeft: '6px',
      width: '11px',
      height: '10px'
    },
    viewButtonLabel: {
      justifyContent: 'unset',
      marginLeft: '8px',
      width: '100%',
      height: '14px'
    }
  };
}, {
  name: 'APMenu'
});
var _default = useStyles;
exports["default"] = _default;